// Checkbox component

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IntlMessage from '../../common/intl/intl_message.jsx'

class Checkbox extends Component {
  constructor (props) {
    super(props)

    this._references = {
      field: React.createRef()
    }
  }

  static get propTypes () {
    return {
      label: PropTypes.string,
      icon: PropTypes.string,
      checked: PropTypes.bool,
      disabled: PropTypes.bool,
      onChange: PropTypes.func,
      onRenderLabel: PropTypes.func,
      className: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      label: '',
      icon: 'checkbox',
      checked: false,
      disabled: false,
      onChange: null,
      onRenderLabel: null,
      className: null
    }
  }

  render () {
    const { label, disabled, checked, icon, onRenderLabel } = this.props
    const iconClassChecked = `icon icon-${icon}-checked checked`
    const iconClassUnchecked = `icon icon-${icon}-uncheck normal`
    const checkboxClass = classnames(
      'form-checkbox',
      {
        'form-checkbox_checked': checked
      },
      this.props.className
    )

    return (
      <div className={checkboxClass}>
        <input
          ref={this._references.field}
          type='checkbox'
          value='1'
          onChange={this._onChange.bind(this)}
          checked={checked}
          disabled={disabled}
          className='field'
        />
        {onRenderLabel
          ? onRenderLabel()
          : label && (
            <span className='label'>
              <IntlMessage ident={label} />
            </span>
          )}
        <span className='icons'>
          <i className={iconClassChecked} />
          <i className={iconClassUnchecked} />
        </span>
      </div>
    )
  }

  /* Event handlers */
  _onChange (_event) {
    let checked = false
    if (this._references.field.current) {
      checked = ReactDOM.findDOMNode(this._references.field.current).checked
    }

    if (this.props.onChange) {
      this.props.onChange(checked)
    }
  }
}

export default Checkbox
